/**
 * Shows a browser notification for an incoming call.
 * Only shows if the page is hidden (user is in another tab/window).
 *
 * @param callerName - Name or phone number of the caller
 * @returns The Notification object if shown, null otherwise
 */
export async function showBrowserCallNotification(callerName: string): Promise<Notification | null> {
  // Only show browser notification if page is hidden
  if (!document.hidden) {
    return null;
  }

  // Request permission if not granted
  if (Notification.permission !== "granted") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }
  }

  // Show browser notification
  const notification = new Notification("Incoming Call", {
    body: `Call from ${callerName}`,
    icon: "/logo512.png",
    badge: "/logo192.png",
    tag: "incoming-call", // Prevents duplicate notifications
    requireInteraction: true, // Keep notification until user interacts
  });

  return notification;
}
